<template>
    <div class="bg-white px2-pc px1-mobile pb-1">
        <div class="backlink mt3-pc">
            <a layout="row" layout-align="start center" @click="$router.push({name: 'admin-settings-users-index'})"><v-icon class="mr-1" color="grey">mdi-chevron-left</v-icon>{{$t('params.back_users')}}</a>
        </div>
        <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb-2 mt3-pc mt1-mobile">{{isNew ? $t('params.new_user') : $t('params.edit_user')}}</div>

        <v-form class="mt5-pc mt3-mobile" layout="column" layout-align="center center" ref="form" v-model="formValid" @submit.prevent="save">
            <div class="width-95-mobile">
                <v-text-field :label="$t('users.firstname')" v-model="user.firstname" class="field-width" :rules="[ v => !!v || $t('errors.required') ]"></v-text-field>
                <v-text-field :label="$t('users.lastname')" v-model="user.lastname" class="field-width" :rules="[ v => !!v || $t('errors.required') ]"></v-text-field>
                <v-text-field label="E-mail" v-model="user.email" class="field-width" :rules="[ v => !!v || $t('errors.required') ]"></v-text-field>

                <v-select v-model="user.lang_id" :label="$t('nav.lang')" :items="$store.state.folangs" item-value="id" :item-text="langName" :rules="[v => !!v || $t('errors.required')]" required></v-select>

                <avatar v-if="user.avatar_id && getImageData(user.id)" size="50" :image="getImageData(user.id)"></avatar>

                <v-text-field :label="$t('users.avatar')"  @click="pickFile" @keyup.enter="pickFile" v-model="imageName" prepend-icon="mdi-image-multiple"></v-text-field>
                <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked">
            </div>

            <div layout="row" layout-align="end center" class="field-width width-95-mobile">
                <v-btn depressed color="secondary" @click="save" style="text-transform: none">{{$t('_.save')}}</v-btn>
                &nbsp;{{$t('_.or')}}&nbsp;
                <router-link :to="{name: 'admin-settings-users-index'}" class="grey--text">{{$t('_.cancel')}}</router-link>
            </div>
        </v-form>
    </div>
</template>

<script>
    import Params from '@/api/params'
    import ImageMixin from '@/mixins/image'
    import Avatar from "@/components/shared/Avatar"
    import I18nMixin from '@/mixins/i18n'
    import FormDataMixin from '@/mixins/formdata'

    export default {
        components: {Avatar},
        mixins: [ImageMixin, I18nMixin, FormDataMixin],
        data () {
            return {
                user: {
                    lang_id: 'fr'
                },
                formValid: false,
                imageData: null,
                imageName: null,
                imgs: {},
                imgsLoad: {},
            }
        },
        mounted () {
            if (!this.isNew) {
                this.fetch();
            }
        },
        methods: {
            fetch () {
                Params.get('users', this.$route.params.id).then(res => {
                    this.user = res.data;

                    if(this.user.avatar_id){
                        this.getImage('/assets/users/' + this.user.id, this.user.id);
                    }
                })
            },
            save () {
                if (!this.$refs.form.validate()) {
                    return;
                }

                // Convert the data to FormData for proper file upload
                let formData = new FormData();
                this._convertObjectToFormData(formData, this.user);

                if (this.imageData) {
                    formData.append("avatar", this.imageData, this.imageName);
                }

                if (this.isNew) {
                    Params.create('users', formData).then(() => {
                        this.$router.push({name: 'admin-settings-users-index'});
                        this.$snotify.success(this.$t('params.user_created'));
                    })
                } else {
                    Params.updateAsForm('users', this.user.id, formData).then(() => {
                        this.$router.push({name: 'admin-settings-users-index'});
                        this.$snotify.success(this.$t('params.user_edited'));
                    })
                }
            },
            pickFile() {
                this.$refs.image.click();
            },
            onFilePicked(e) {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    this.imageData = files[0];
                    this.imageName = files[0].name;
                }
            },
            langName(item){
                return this.i18n(item.name);
            }
        },
        computed: {
            isNew () {
                return this.$route.params.id === 'new';
            }
        }
    }
</script>